<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllBdl"></b-form-checkbox>
        <span @click="checkedAllBdl = !checkedAllBdl">BDL</span>
        <div style="float: right;">
          <span id="bdl-label-color"
            :style="{ display: 'inline-block', width: '18px', height: '18px', borderRadius: '50%', backgroundColor: bdlLabelColorCss, cursor: 'pointer', border: '2px solid #ccc', marginRight: '6px', verticalAlign: 'middle' }"></span>
          <b-popover target="bdl-label-color" triggers="focus" placement="top">
            <template v-slot:title>Label color</template>
            <SketchPicker v-model="bdlLabelColor" :presetColors="bdlLabelPresetColors" :disableAlpha="true"
              :disableFields="true" />
          </b-popover>
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;"
            :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
        <div class="bdl-filter-controls">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="openBdlFilterModal">Filter</button>
          <button v-if="bdlFilter" type="button" class="btn btn-sm btn-outline-secondary"
            @click="resetBdlFilter">Reset</button>
          <span v-if="bdlFilter" class="bdl-filter-summary">{{ bdlFilterSummary }}</span>
        </div>
        <div class="bdl-plot-count">Wyświetlane działki: {{ visiblePlotCount }} z {{ bdlPlotCount }}</div>
      </div>
    </div>
    <div ref="bdlFilterModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="bdlFilterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="bdlFilterTitle" class="modal-title">Filtr działek leśnych</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Zamknij"></button>
          </div>
          <div class="modal-body">
            <div class="bdl-filter-grid">
              <label>
                <span>Piętro</span>
                <select v-model="filterDraft.storeys" class="form-select" multiple size="6">
                  <option v-for="option in storeyOptions" :key="option.value" :value="option.value">{{ option.value }}
                    ({{
                    option.count }})</option>
                </select>
              </label>
              <label>
                <span>Gatunek</span>
                <select v-model="filterDraft.species" class="form-select" multiple size="6">
                  <option v-for="option in speciesOptions" :key="option.value" :value="option.value">{{ option.value }}
                    ({{
                    option.count }})</option>
                </select>
              </label>
              <label>
                <span>Udział od</span>
                <select v-model="filterDraft.partFrom" class="form-select">
                  <option v-for="option in participationFromOptions" :key="option.value" :value="option.value">{{
                    option.label }}</option>
                </select>
              </label>
              <label>
                <span>Udział do</span>
                <select v-model="filterDraft.partTo" class="form-select">
                  <option v-for="option in participationToOptions" :key="option.value" :value="option.value">{{
                    option.label
                    }}</option>
                </select>
              </label>
              <label>
                <span>Wiek od</span>
                <input v-model.number="filterDraft.ageFrom" type="number" min="1" step="1" class="form-control" />
              </label>
              <label>
                <span>Wiek do</span>
                <input v-model.number="filterDraft.ageTo" type="number" min="1" step="1" class="form-control" />
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="applyBdlFilter">Zastosuj</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bdl-filter-controls {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.bdl-filter-summary,
.bdl-plot-count {
  font-size: 12px;
}

.bdl-plot-count {
  margin-top: 6px;
}

.bdl-filter-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(110px, 1fr));
  gap: 10px;
}

.bdl-filter-grid label {
  min-width: 0;
  font-weight: 600;
}

.bdl-filter-grid label>span {
  display: block;
  margin-bottom: 5px;
}

.bdl-filter-grid select[multiple] {
  min-height: 144px;
}

:global(.leaflet-container.bdl-pointer-cursor),
:global(.leaflet-container.bdl-pointer-cursor *) {
  cursor: pointer !important;
}

@media (max-width: 900px) {
  .bdl-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

:deep(.bdl-popup .leaflet-popup-content-wrapper) {
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.17);
}

:deep(.bdl-popup .leaflet-popup-content) {
  width: 760px !important;
  max-width: min(760px, 72vw) !important;
  margin: 0 !important;
  padding: 0;
  box-sizing: border-box;
  overflow: visible !important;
}

:deep(.bdl-popup .leaflet-popup-content-wrapper) {
  overflow: visible !important;
}

:deep(.bdl-popup .leaflet-popup-tip) {
  background: white;
}

:deep(.bdl-popup-pwa .leaflet-popup-content) {
  width: min(88vw, 420px) !important;
  max-width: min(88vw, 420px) !important;
  max-height: 55vh;
  overflow: auto !important;
}

:deep(.bdl-popup-pwa .leaflet-popup-content-wrapper) {
  max-width: 92vw;
}

:global(.bdl-label) {
  background: transparent;
  border: 0;
  border-radius: 0;
  width: 0;
  height: 0;
}

:global(.bdl-label-text) {
  color: #111;
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-50%, -50%);
  white-space: pre-line;
}

@media (max-width: 900px) {
  :deep(.bdl-popup .leaflet-popup-content) {
    width: min(88vw, 560px) !important;
    max-width: min(88vw, 560px) !important;
  }
}
</style>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import { AlertStatus, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";
import { DeckOverlay } from '@deck.gl-community/leaflet';
import { PolygonLayer } from '@deck.gl/layers';
import Flatbush from 'flatbush';
import pointInPolygon from '@/ts/pointInPolygon';

interface BdlInstanceState {
  bdlResults: any[];
  bdlPlots: any[];
  bdlProcessed: boolean;
  labelsLayer: (L.Layer & { needRedraw(): void; _canvas?: HTMLCanvasElement }) | null;
  deckOverlay: DeckOverlay | null;
  polygonPositions: Float32Array;
  polygonIndices: Uint32Array;
  polygonData: {
    length: number;
    startIndices: Uint32Array;
    attributes: { getPolygon: { value: Float32Array; size: number } };
  };
  polygonPlotIndices: Uint32Array;
  polygonVisibility: Uint8Array;
  polygonSpatialIndex: Flatbush | null;
  hoverPolygon: L.Polygon;
  hoveredPolygonIndex: number;
  mapMouseMoveHandler: ((event: L.LeafletMouseEvent) => void) | null;
  mapClickHandler: ((event: L.LeafletMouseEvent) => void) | null;
}

declare module 'vue' {
  interface ComponentCustomProperties extends BdlInstanceState {}
}

export default defineComponent({
  extends: BaseComponent,
  data() {

    return {
      checkedAllBdl: false,
      loading: false,
      expanded: false,
      active: true,
      inactive: false,
      bdlLoaded: false,
      bdlPlotCount: 0,
      visiblePlotCount: 0,
      storeyOptions: [] as Array<{ value: string; count: number }>,
      speciesOptions: [] as Array<{ value: string; count: number }>,
      nonNumericPartValues: [] as string[],
      bdlFilter: null as any,
      filterDraft: {
        storeys: ['DRZEW'] as string[],
        species: [] as string[],
        partFrom: '0',
        partTo: '10',
        ageFrom: '',
        ageTo: '',
      }, 
      bdlLabelColor: { r: 17, g: 17, b: 17, a: 1 },
      bdlLabelPresetColors: ['#111111', '#FF0000', '#0000FF', '#008000', '#FF8C00', '#800080', '#FFFFFF', '#000000']
    };
  },
  computed: {
    bdlLabelColorCss(): string {
      const color: any = this.bdlLabelColor;
      if (typeof color === 'string') return color;
      if (color && color.hex) return color.hex;
      if (color && color.rgba) {
        return `rgba(${color.rgba.r}, ${color.rgba.g}, ${color.rgba.b}, ${color.rgba.a ?? 1})`;
      }
      if (color && color.r !== undefined) {
        return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a ?? 1})`;
      }
      return '#111111';
    },
    participationFromOptions(): Array<{ value: string; label: string }> {
      const options = Array.from({ length: 10 }, (_, index) => {
        const value = String(10 - index);
        return { value, label: value };
      });
      if (this.nonNumericPartValues.length) {
        options.push({ value: '__NON_NUMERIC__', label: this.nonNumericPartValues.join('/') });
      }
      options.push({ value: '0', label: '0' });
      return options;
    },
    participationToOptions(): Array<{ value: string; label: string }> {
      const options = Array.from({ length: 10 }, (_, index) => {
        const value = String(10 - index);
        return { value, label: value };
      });
      if (this.nonNumericPartValues.length) {
        options.push({ value: '__NON_NUMERIC__', label: this.nonNumericPartValues.join('/') });
      }
      return options;
    },
    bdlFilterSummary(): string {
      if (!this.bdlFilter) return '';
      const describe = (values: string[]) => values.length ? values.join(', ') : 'dowolne';
      const describeBound = (value: string) => value === '__NON_NUMERIC__' ? this.nonNumericPartValues.join('/') : value || 'brak';
      return `Piętro: ${describe(this.bdlFilter.storeys)}; gatunek: ${describe(this.bdlFilter.species)}; udział: ${describeBound(this.bdlFilter.partFrom)}–${describeBound(this.bdlFilter.partTo)}; wiek: ${this.bdlFilter.ageFrom || 'brak'}–${this.bdlFilter.ageTo || 'brak'}`;
    },
  },
  created() {
    this.bdlResults = [];
    this.bdlPlots = [];
    this.bdlProcessed = false;
    this.labelsLayer = null;
    this.deckOverlay = null;
    this.polygonPositions = new Float32Array(0);
    this.polygonIndices = new Uint32Array([0]);
    this.polygonData = {
      length: 0,
      startIndices: this.polygonIndices,
      attributes: { getPolygon: { value: this.polygonPositions, size: 2 } },
    };
    this.polygonPlotIndices = new Uint32Array(0);
    this.polygonVisibility = new Uint8Array(0);
    this.polygonSpatialIndex = null;
    this.hoverPolygon = L.polygon([], {
      color: 'yellow',
      fillColor: 'yellow',
      fillOpacity: 0,
      weight: 3,
      interactive: false,
    });
    this.hoveredPolygonIndex = -1;
    this.mapMouseMoveHandler = null;
    this.mapClickHandler = null;
    EventBus.$on('downloadExternalData', () => this.downloadBdl());
    EventBus.$on('toggleBdl', () => {
      if (this.bdlLoaded) {
        this.checkedAllBdl = !this.checkedAllBdl;
      }
    });
    EventBus.$on('selectedAreaChanged', () => this.onSelectedAreaChanged());
  },
  beforeUnmount() {
    if (window.mainmap && this.mapMouseMoveHandler) {
      window.mainmap.off('mousemove', this.mapMouseMoveHandler);
    }
    if (window.mainmap && this.mapClickHandler) {
      window.mainmap.off('click', this.mapClickHandler);
    }
    this.hideBdlHoverPolygon();
  },
  methods: {

    ensureBdlLabelsLayer() {
      if (!window.mainmap || this.labelsLayer) return;
      // @ts-ignore L.CanvasLayer is registered by main.ts.
      this.labelsLayer = L.canvasLayer().delegate(this);
      this.labelsLayer.addTo(window.mainmap);
      if (this.labelsLayer._canvas) {
        this.labelsLayer._canvas.style.pointerEvents = 'none';
      }
    },

    redrawBdlLabels() {
      if (this.labelsLayer) {
        this.labelsLayer.needRedraw();
      }
    },

    ensureBdlDeckOverlay() {
      if (!window.mainmap || this.deckOverlay) return;
      this.deckOverlay = new DeckOverlay({ layers: [] });
      window.mainmap.addLayer(this.deckOverlay);
    },

    ensureBdlMapHandlers() {
      if (!window.mainmap || !window.isDesktop) return;
      if (!this.mapMouseMoveHandler) {
        this.mapMouseMoveHandler = (event: L.LeafletMouseEvent) => this.onBdlMapMouseMove(event);
        window.mainmap.on('mousemove', this.mapMouseMoveHandler);
      }
      if (!this.mapClickHandler) {
        this.mapClickHandler = (event: L.LeafletMouseEvent) => this.onBdlMapClick(event);
        window.mainmap.on('click', this.mapClickHandler);
      }
    },

    hideBdlHoverPolygon() {
      window.mainmap?.getContainer().classList.remove('bdl-pointer-cursor');
      if (window.mainmap?.hasLayer(this.hoverPolygon)) {
        this.hoverPolygon.removeFrom(window.mainmap);
      }
      this.hoveredPolygonIndex = -1;
    },

    findVisibleBdlPolygonAt(point: L.LatLng): number {
      const spatialIndex = this.polygonSpatialIndex;
      if (!this.checkedAllBdl || !this.bdlProcessed || !spatialIndex) return -1;

      const { lat, lng } = point;
      const candidates = spatialIndex.search(lng, lat, lng, lat);
      for (let candidatePosition = candidates.length - 1; candidatePosition >= 0; candidatePosition -= 1) {
        const polygonIndex = candidates[candidatePosition];
        if (!this.polygonVisibility[polygonIndex]) continue;
        if (pointInPolygon([lng, lat], this.polygonPositions, this.polygonIndices, polygonIndex) !== false) {
          return polygonIndex;
        }
      }
      return -1;
    },

    onBdlMapMouseMove(event: L.LeafletMouseEvent) {
      const hitPolygonIndex = this.findVisibleBdlPolygonAt(event.latlng);

      if (hitPolygonIndex < 0) {
        this.hideBdlHoverPolygon();
        return;
      }
      window.mainmap.getContainer().classList.add('bdl-pointer-cursor');
      if (hitPolygonIndex === this.hoveredPolygonIndex) return;

      const leafletPoints: L.LatLngExpression[] = [];
      const startIndex = this.polygonIndices[hitPolygonIndex];
      const endIndex = this.polygonIndices[hitPolygonIndex + 1];
      for (let index = startIndex; index < endIndex; index += 1) {
        const coordinateIndex = index * 2;
        leafletPoints.push([
          this.polygonPositions[coordinateIndex + 1],
          this.polygonPositions[coordinateIndex],
        ]);
      }
      this.hoverPolygon.setLatLngs(leafletPoints);
      this.hoveredPolygonIndex = hitPolygonIndex;
      if (!window.mainmap.hasLayer(this.hoverPolygon)) {
        this.hoverPolygon.addTo(window.mainmap);
      }
      this.hoverPolygon.bringToFront();
    },

    onBdlMapClick(event: L.LeafletMouseEvent) {
      const polygonIndex = this.findVisibleBdlPolygonAt(event.latlng);
      if (polygonIndex >= 0) {
        this.openBdlPopup(polygonIndex, event.latlng);
      }
    },

    updateBdlPolygonLayer() {
      if (!this.checkedAllBdl) {
        if (this.deckOverlay) {
          this.deckOverlay.setProps({ layers: [] });
          return
        }
        return;
      }
      this.ensureBdlDeckOverlay();
      if (!this.deckOverlay) {
        return;
      }

      const lineColorTrigger = Array.from(this.polygonVisibility);
      const layer = new PolygonLayer({
        id: 'bdl-polygons',
        data: this.polygonData,
        positionFormat: 'XY',
        _normalize: false,
        getPolygon: (object, info) => {
          const data = info.data as BdlInstanceState['polygonData'];
          return data.attributes.getPolygon.value.subarray(
            data.startIndices[info.index] * 2,
            data.startIndices[info.index + 1] * 2,
          );
        },
        getFillColor: [0, 0, 0, 0],
        getLineColor: (object, info) => {
          return this.polygonVisibility[info.index] ? [255, 0, 0, 255] : [255, 0, 0, 0]
        },
        updateTriggers: { 
          getLineColor: lineColorTrigger 
        },
        getLineWidth: 2,
        lineWidthUnits: 'pixels',
        lineWidthMinPixels: 2,
        pickable: false,
      });
      this.deckOverlay.setProps({ layers: [layer] });
    },

    openBdlPopup(polygonIndex: number, coordinate: L.LatLng) {
      const plotIndex = this.polygonPlotIndices[polygonIndex];
      const plot = this.bdlPlots[plotIndex];
      if (!plot) return;

      const isNarrowViewport = window.innerWidth <= 900;
      L.popup({
        maxWidth: isNarrowViewport ? Math.min(window.innerWidth * 0.88, 560) : 760,
        minWidth: isNarrowViewport ? 0 : 560,
        className: isNarrowViewport ? 'bdl-popup bdl-popup-pwa' : 'bdl-popup',
        autoPan: true,
        keepInView: true,
        closeOnClick: false,
      }).setLatLng(coordinate).setContent(this.buildBdlPopupHtml(plot)).openOn(window.mainmap);
    },

    isPointInSelectedArea(lat: number | string, lon: number | string) {
      // @ts-ignore
      const areaKey = window.selectedArea;
      if (!areaKey) return true;
      // @ts-ignore
      const area = window.areas[areaKey];
      if (!area || !area[0] || !area[1]) return true;
      const minLat = Math.min(area[0][0], area[1][0]);
      const maxLat = Math.max(area[0][0], area[1][0]);
      const minLon = Math.min(area[0][1], area[1][1]);
      const maxLon = Math.max(area[0][1], area[1][1]);
      const plat = Number(lat);
      const plon = Number(lon);
      if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
      return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
    },

    extractBdlPolygonParts(points: any): any[] {
      if (!Array.isArray(points) || !points.length) return [];
      const first = points[0];
      if (Array.isArray(first) && first.length && Array.isArray(first[0]) && first[0].length >= 2 && typeof first[0][0] === 'number') {
        return points;
      }
      if (Array.isArray(first) && first.length >= 2 && typeof first[0] === 'number' && typeof first[1] === 'number') {
        return [points];
      }
      return [];
    },

    isPathInSelectedArea(path: any[]) {
      if (!path || !path.length) return false;
      const flattened: Array<[number, number]> = [];
      const walk = (value: any) => {
        if (Array.isArray(value)) {
          if (value.length >= 2 && typeof value[0] === 'number' && typeof value[1] === 'number') {
            flattened.push([value[0], value[1]]);
            return;
          }
          for (const item of value) {
            walk(item);
          }
        }
      };
      walk(path);
      return flattened.some(([lat, lon]) => this.isPointInSelectedArea(lat, lon));
    },

    parseDetails(value: any) {
      if (!value) return null;
      if (typeof value === 'string') {
        try {
          return JSON.parse(value);
        } catch (e) {
          return null;
        }
      }
      return value;
    },
    getLayerSpecies(details: any) {
      const parsedDetails = this.parseDetails(details);
      const layerSpecies = Array.isArray(parsedDetails)
        ? parsedDetails
        : parsedDetails?.layerSpecies;
      if (!Array.isArray(layerSpecies)) return [];
      return layerSpecies.map((row: any) => {
        if (Array.isArray(row)) {
          return {
            storey_cd: row[0],
            species_cd: row[1],
            part_cd: row[2],
            species_age: row[3],
          };
        }
        return row;
      });
    },
    getDetailCode(value: any): string {
      return String(value ?? '').split(':', 1)[0].trim();
    },
    isNumericValue(value: any): boolean {
      return String(value ?? '').trim() !== '' && Number.isFinite(Number(value));
    },
    updateBdlFilterOptions(results: any[]) {
      const storeyCounts = new Map<string, number>();
      const speciesCounts = new Map<string, number>();
      const nonNumericParts = new Set<string>();
      for (const plot of results) {
        for (const row of this.getLayerSpecies(plot?.details)) {
          const storey = this.getDetailCode(row?.storey_cd);
          const species = this.getDetailCode(row?.species_cd);
          const part = this.getDetailCode(row?.part_cd);
          if (storey) storeyCounts.set(storey, (storeyCounts.get(storey) || 0) + 1);
          if (species) speciesCounts.set(species, (speciesCounts.get(species) || 0) + 1);
          if (part && !this.isNumericValue(part)) nonNumericParts.add(part);
        }
      }
      const toOptions = (counts: Map<string, number>) => Array.from(counts, ([value, count]) => ({ value, count }))
        .sort((left, right) => right.count - left.count || left.value.localeCompare(right.value));
      this.storeyOptions = toOptions(storeyCounts);
      this.speciesOptions = toOptions(speciesCounts);
      this.nonNumericPartValues = Array.from(nonNumericParts).sort((left, right) => left.localeCompare(right));
    },
    createDefaultBdlFilter(): { storeys: string[]; species: string[]; partFrom: string; partTo: string; ageFrom: string; ageTo: string } {
      return { storeys: ['DRZEW'], species: [], partFrom: '0', partTo: '10', ageFrom: '', ageTo: '' };
    },
    openBdlFilterModal() {
      this.filterDraft = this.bdlFilter
        ? { ...this.bdlFilter, storeys: [...this.bdlFilter.storeys], species: [...this.bdlFilter.species] }
        : this.createDefaultBdlFilter();
      this.openModal(this.$refs.bdlFilterModal as HTMLElement);
    },
    applyBdlFilter() {
      this.bdlFilter = {
        ...this.filterDraft,
        storeys: [...this.filterDraft.storeys],
        species: [...this.filterDraft.species],
      };
      this.closeModal(this.$refs.bdlFilterModal as HTMLElement);
      this.onCheckedAllBdlChanged();
    },
    resetBdlFilter() {
      this.bdlFilter = null;
      this.onCheckedAllBdlChanged();
    },
    getComparableNumber(value: any, emptyValue: number): number {
      const normalized = this.getDetailCode(value);
      if (!normalized) return emptyValue;
      return this.isNumericValue(normalized) ? Number(normalized) : 0.5;
    },
    matchesBdlFilter(plot: any): boolean {
      if (!this.bdlFilter) return true;
      const filter = this.bdlFilter;
      const rows = this.getLayerSpecies(plot?.details);
      return rows.some((row: any) => {
        const storey = this.getDetailCode(row?.storey_cd);
        const species = this.getDetailCode(row?.species_cd);
        const selectedStorey = !filter.storeys.length || filter.storeys.includes(storey);
        const selectedSpecies = !filter.species.length || filter.species.includes(species);
        const part = this.getComparableNumber(row?.part_cd, 0);
        const partFrom = filter.partFrom === '__NON_NUMERIC__' ? 0.5 : this.getComparableNumber(filter.partFrom, 0);
        const partTo = filter.partTo === '__NON_NUMERIC__' ? 0.5 : this.getComparableNumber(filter.partTo, 10);
        const age = this.getComparableNumber(row?.species_age, 0);
        const ageFrom = this.getComparableNumber(filter.ageFrom, 0);
        const ageTo = this.getComparableNumber(filter.ageTo, 1000000);
        return selectedStorey && selectedSpecies
          && part >= partFrom && part <= partTo
          && age >= ageFrom && age <= ageTo;
      });
    },
    escapeHtml(value: any) {
      return String(value ?? '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char as keyof Record<string, string>] || char));
    },
    buildBdlPopupHtml(responseTour: any) {
      const rows = this.getLayerSpecies(responseTour?.details);
      if (!rows.length) {
        return '<div style="font-size: 12px;">Brak danych</div>';
      }

      const columns = [
        ['storey_cd', 'Warstwa'],
        ['species_cd', 'Gatunek'],
        ['part_cd', 'Udział'],
        ['species_age', 'Wiek'],
      ];
      const headerHtml = '<tr>' + columns.map((column) => {
        return '<th style="padding: 8px 10px; border: 1px solid #d7d7d7; background: #f4f4f4; font-weight: 700; text-align: left; white-space: nowrap;">'
          + this.escapeHtml(column[1])
          + '</th>';
      }).join('') + '</tr>';

      const rowsHtml = rows.map((row: any) => {
        const cells = columns.map((column) => {
          const value = row?.[column[0]] ?? '';
          const displayValue = typeof value === 'string'
            ? value.replace(/:.*/, '')
            : value;
          return '<td style="padding: 8px 10px; border: 1px solid #d7d7d7; vertical-align: top; word-break: break-word;">'
            + this.escapeHtml(displayValue)
            + '</td>';
        }).join('');
        return '<tr>' + cells + '</tr>';
      }).join('');

      return '<div class="bdl-popup-content" style="width: 100%; max-width: 760px; font-size: 12px; line-height: 1.35; padding: 4px; box-sizing: border-box;">'
        + '<table style="border-collapse: separate; border-spacing: 0; width: 100%; table-layout: fixed; border: 1px solid #cfcfcf; min-width: 100%;">'
        + '<thead>' + headerHtml + '</thead>'
        + '<tbody>' + rowsHtml + '</tbody>'
        + '</table></div>';
    },
    getBdlLabelText(responseTour: any, zoom: number) {
      const treeRows = this.getLayerSpecies(responseTour?.details).filter((row: any) => {
        const layer = row?.storey_cd;
        return typeof layer === 'string' && layer.split(':', 1)[0] === 'DRZEW';
      });
      if (!treeRows.length) return '';

      const maxRows = zoom >= 18 ? treeRows.length : zoom >= 17 ? 3 : zoom >= 16 ? 2 : zoom >= 15 ? 1 : 0;
      if (!maxRows) return '';

      const getDisplayValue = (value: any) => typeof value === 'string' ? value.replace(/:.*/, '') : value ?? '';
      const rowsToDisplay = treeRows.slice(0, maxRows);
      return rowsToDisplay.map((row: any) => {
        const species = getDisplayValue(row.species_cd);
        const part = getDisplayValue(row.part_cd);
        const age = getDisplayValue(row.species_age);
        return rowsToDisplay.length >= 2 ? `${species}:${part}:${age}` : `${species}:${age}`;
      }).join('\n');
    },
    onDrawLayer(info: any) {
      const ctx = info.canvas.getContext('2d');
      if (!ctx) return;
      ctx.clearRect(0, 0, info.canvas.width, info.canvas.height);

      const zoom = Math.floor(info.zoom);
      if (!this.checkedAllBdl || zoom < 15) return;

      ctx.font = '700 12px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = this.bdlLabelColorCss;

      const drawnLabels = new Set<string>();
      const visiblePlots = new Set<number>();
      const bounds = info.bounds;
      const candidatePolygons = this.polygonSpatialIndex?.search(
        bounds.getWest(),
        bounds.getSouth(),
        bounds.getEast(),
        bounds.getNorth(),
      ) ?? [];
      for (const polygonIndex of candidatePolygons) {
        if (this.polygonVisibility[polygonIndex]) {
          visiblePlots.add(this.polygonPlotIndices[polygonIndex]);
        }
      }
      for (const plotIndex of visiblePlots) {
        const plot = this.bdlPlots[plotIndex];
        const rawLabelCoords = plot?.label;
        if (!Array.isArray(rawLabelCoords) || rawLabelCoords.length < 2
          || !Number.isFinite(Number(rawLabelCoords[0])) || !Number.isFinite(Number(rawLabelCoords[1]))) continue;
        const labelCoords = [Number(rawLabelCoords[0]), Number(rawLabelCoords[1])];
        if (!labelCoords || !info.bounds.contains(labelCoords)) continue;

        const labelText = this.getBdlLabelText(plot, zoom);
        if (!labelText) continue;
        const labelKey = `${labelCoords[0]}:${labelCoords[1]}:${labelText}`;
        if (drawnLabels.has(labelKey)) continue;
        drawnLabels.add(labelKey);

        const point = info.layer._map.latLngToContainerPoint(labelCoords);
        const lines = labelText.split('\n');
        const lineHeight = 14;
        const startY = point.y - ((lines.length - 1) * lineHeight) / 2;
        for (let index = 0; index < lines.length; index += 1) {
          ctx.fillText(lines[index], point.x, startY + index * lineHeight);
        }
      }
    },
    onSelectedAreaChanged() {
      if (this.bdlLoaded) {
        this.bdlProcessed = false;
        if (this.checkedAllBdl) {
          this.processBdl();
          this.onCheckedAllBdlChanged();
        }
      }
    },
    downloadBdl() {
      this.loading = true;
      const endPoint = window.apiHost + 'api/stringfield/bdl/';
      this.downloadUrlWithCache(endPoint, 'bdl', 'bdl.txt', null, true).then((response) => {
        const results = response[1].results;
        this.bdlResults = results;
        //window.__MIERZENIE = this.bdlResults;
        this.updateBdlFilterOptions(results);
        this.bdlLoaded = true;
        if (response[0] == DownloadStatus.cache_fresh) {
          this.createAlert(AlertStatus.success, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.api_fresh) {
          this.createAlert(AlertStatus.success, this.$t('toursDownloaded', [response[1].results.length]).toString(), 2000);
        }
        if (response[0] == DownloadStatus.cache_last) {
          this.createAlert(AlertStatus.warning, this.$t('toursLoaded', [response[1].results.length]).toString(), 2000);
        }
      }).catch((error) => {
        this.createAlert(AlertStatus.danger, this.$t('toursError').toString(), 2000);
      }).finally(() => {
        this.loading = false;
      });
    },
    processBdl() {
      this.hideBdlHoverPolygon();
      const plots: any[] = [];
      const polygonCoordinates: number[] = [];
      const polygonIndices = [0];
      const polygonPlotIndices: number[] = [];
      const polygonBounds: Array<[number, number, number, number]> = [];
      for (const responseTour of this.bdlResults) {
        const polygonParts = this.extractBdlPolygonParts(responseTour['points']);
        if (!polygonParts.length || !this.isPathInSelectedArea(responseTour['points'])) {
          continue;
        }
        const plotIndex = plots.length;
        let hasValidPolygon = false;

        for (const polygonPoints of polygonParts) {
          let minLng = Infinity;
          let minLat = Infinity;
          let maxLng = -Infinity;
          let maxLat = -Infinity;
          let validPolygon = polygonPoints.length >= 3;

          for (const coordinate of polygonPoints) {
            const lat = Number(coordinate[0]);
            const lng = Number(coordinate[1]);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
              validPolygon = false;
              break;
            }
            minLng = Math.min(minLng, lng);
            minLat = Math.min(minLat, lat);
            maxLng = Math.max(maxLng, lng);
            maxLat = Math.max(maxLat, lat);
          }

          if (!validPolygon) continue;
          const first = polygonPoints[0];
          const last = polygonPoints[polygonPoints.length - 1];
          for (const coordinate of polygonPoints) {
            polygonCoordinates.push(Number(coordinate[1]), Number(coordinate[0]));
          }
          if (Number(first[0]) !== Number(last[0]) || Number(first[1]) !== Number(last[1])) {
            polygonCoordinates.push(Number(first[1]), Number(first[0]));
          }
          polygonIndices.push(polygonCoordinates.length / 2);
          polygonPlotIndices.push(plotIndex);
          polygonBounds.push([minLng, minLat, maxLng, maxLat]);
          hasValidPolygon = true;
        }

        if (hasValidPolygon) {
          plots.push(responseTour);
        }
      }
      this.bdlPlots = plots;
      this.bdlPlotCount = plots.length;
      this.polygonPositions = new Float32Array(polygonCoordinates);
      this.polygonIndices = new Uint32Array(polygonIndices);
      this.polygonData = {
        length: polygonPlotIndices.length,
        startIndices: this.polygonIndices,
        attributes: { 
          getPolygon: { 
            value: this.polygonPositions, size: 2 
          } 
        },
      };
      this.polygonPlotIndices = new Uint32Array(polygonPlotIndices);
      this.polygonVisibility = new Uint8Array(polygonPlotIndices.length);
      //window.__MIERZENIE = this.bdlPlots;
      if (polygonBounds.length) {
        const spatialIndex = new Flatbush(polygonBounds.length, 16, Float32Array);
        for (const [minLng, minLat, maxLng, maxLat] of polygonBounds) {
          spatialIndex.add(minLng, minLat, maxLng, maxLat);
        }
        spatialIndex.finish();
        this.polygonSpatialIndex = spatialIndex;
      } else {
        this.polygonSpatialIndex = null;
      }
      this.bdlProcessed = true;
    },
    onCheckedAllBdlChanged() {
      if (!this.bdlLoaded) return;
      if (this.checkedAllBdl && !this.bdlProcessed) {
        this.processBdl();
      }
      const visiblePlotIndices = new Set<number>();
      for (let polygonIndex = 0; polygonIndex < this.polygonVisibility.length; polygonIndex += 1) {
        const plotIndex = this.polygonPlotIndices[polygonIndex];
        const plot = this.bdlPlots[plotIndex];
        const statusVisible = plot?.is_active ? this.active : this.inactive;
        const visible = this.checkedAllBdl && statusVisible && this.matchesBdlFilter(plot);
        this.polygonVisibility[polygonIndex] = Number(visible);
        if (visible) {
          visiblePlotIndices.add(plotIndex);
        }
      }
      this.visiblePlotCount = visiblePlotIndices.size;
      if (this.checkedAllBdl) {
        this.ensureBdlLabelsLayer();
        this.ensureBdlMapHandlers();
      } else if (this.labelsLayer) {
        this.labelsLayer.removeFrom(window.mainmap);
        this.labelsLayer = null;
      }
      if (!this.checkedAllBdl) this.hideBdlHoverPolygon();
      this.updateBdlPolygonLayer();
      this.redrawBdlLabels();
    }
  },
  watch: {
    "checkedAllBdl": [{
      handler: "onCheckedAllBdlChanged"
    }],
    "active": [{
      handler: "onCheckedAllBdlChanged"
    }],
    "inactive": [{
      handler: "onCheckedAllBdlChanged"
    }],
    "bdlLabelColor": [{
      handler: "redrawBdlLabels"
    }]
  }
})

</script>
